<template>
  <v-container fluid>
    <v-row class="flex-grow-1" v-if="memorableMoment">
      <v-col>
        <v-row>
          <v-col>
            <v-text-field readonly
                          :label="$t('admin_memorable_moment.memorable_moment_enabled')"
                          :value="memorableMoment.enabled ? $t('admin_memorable_moment.enable') : $t('admin_memorable_moment.disable')"></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-btn block
                   color="primary"
                   v-if="!memorableMoment.enabled"
                   @click="enableEventMemorableMoment">{{ $t('admin_memorable_moment.enable') }}
            </v-btn>
            <v-btn block
                   color="primary"
                   v-if="memorableMoment.enabled"
                   @click="disableEventMemorableMoment">{{ $t('admin_memorable_moment.disable') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-input hide-details="auto"
                     v-model="memorableMoment.cover">
              <v-container fluid class="flex-column">
                <legend class="v-label theme--light">{{ $t('admin_memorable_moment.cover') }}</legend>
                <PhotoPreviewInput v-model="memorableMoment.cover"
                                   div-class="memorable-moment-cover"
                                   file-name="memorable-moment-cover"></PhotoPreviewInput>
                <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>833(W) X 588(H)</b></small>
              </v-container>
            </v-input>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex flex-column">
        <v-row class="flex-grow-0">
          <v-col>
            <v-input hide-details>
              <v-container fluid class="flex-column">
                <v-file-input :label="$t('admin_memorable_moment.add_photo')"
                              v-model="momentUploadedFile"
                              @change="momentAdded"></v-file-input>
                <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>2371(W) X 787(H)</b></small>
              </v-container>
            </v-input>
          </v-col>
        </v-row>
        <v-data-table :items="moments"
                      :headers="memorableMomentHeaders"
                      :items-per-page="-1"
                      hide-default-footer
                      class="memorable-moment-list--table">
          <template #item.photo="{value}">
            <v-img :src="getURL(value)"
                   max-width="150px"
                   max-height="150px"
                   contain></v-img>
          </template>
          <template v-slot:item.actions="{item}">
            <v-row>
              <v-col>
                <v-btn icon
                       @click="moveMomentUp(item)">
                  <v-icon>fas fa-arrow-up</v-icon>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn icon
                       @click="moveMomentDown(item)">
                  <v-icon>fas fa-arrow-down</v-icon>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn icon
                       @click="removeMoment(item)">
                  <v-icon>fas fa-trash</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {nextTick, onMounted, ref} from "@vue/composition-api";
import _ from "lodash";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";

export default {
  name: 'EventMemorableMoment',
  components: {PhotoPreviewInput},
  props: {
    eventId: String,
    reset: Function,
    save: Function,
  },
  setup(props, {root, emit}) {
    onMounted(() => {
      getMemorableMoment();

      emit('update:reset', getMemorableMoment);
      emit('update:save', save);
    })

    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    };

    const memorableMoment = ref(null);
    const moments = ref([]);
    const getMemorableMoment = function () {
      root.$callAPI('hkiarace/admin/event/memorable_moment/', {event_id: props.eventId}, function (response) {
        response.body.moments.sort(function (a, b) {
          if (a.order === b.order) {
            return 0;
          } else {
            return a.order > b.order ? 1 : -1;
          }
        });

        memorableMoment.value = {
          cover: response.body.cover,
          enabled: response.body.enabled,
        };

        moments.value = response.body.moments;
      });
    };
    const enableEventMemorableMoment = function () {
      root.$callAPI('hkiarace/admin/event/memorable_moment/enable/', {event_id: props.eventId}, () => {
        getMemorableMoment();
      })
    }
    const disableEventMemorableMoment = function () {
      root.$callAPI('hkiarace/admin/event/memorable_moment/disable/', {event_id: props.eventId}, () => {
        getMemorableMoment();
      })
    }

    const memorableMomentHeaders = ref([
      {text: root.$t('admin_memorable_moment.photo'), value: 'photo'},
      {text: '', value: 'actions'},
    ]);

    const momentUploadedFile = ref(null);
    const momentAdded = function (f) {
      if (f) {
        moments.value.push({photo: f});

        nextTick(() => {
          momentUploadedFile.value = null;
        });
      }
    }
    const moveMomentUp = function (item) {
      let index = _.findIndex(moments.value, item);
      if (index === 0) return;
      let movingMoment = moments.value.splice(index, 1)[0];
      moments.value.splice(index - 1, 0, movingMoment);
    }
    const moveMomentDown = function (item) {
      let index = _.findIndex(moments.value, item);
      if (index === moments.value.length - 1) return;
      let movingMoment = moments.value.splice(index, 1)[0];
      moments.value.splice(index + 1, 0, movingMoment);
    }
    const removeMoment = function (item) {
      let index = _.findIndex(moments.value, {id: item.id});

      moments.value.splice(index, 1);
    }
    const save = async function () {
      let orderedMoments = await Promise.all(moments.value.map(async (m, index) => {
        return {
          photo: m.photo instanceof File ? await root.$convertFileToBase64(m.photo) : m.photo,
          order: index,
        }
      }));

      root.$callAPI('hkiarace/admin/event/memorable_moment/set/', {
        event_id: props.eventId,
        cover: memorableMoment.value.cover instanceof File ? await root.$convertFileToBase64(memorableMoment.value.cover) : memorableMoment.value.cover,
        moments: orderedMoments,
      }, () => {
        root.$showAlertMessage('Save Successful');
        getMemorableMoment();
      })
    };

    return {
      getURL,
      memorableMoment,
      moments,
      getMemorableMoment,
      disableEventMemorableMoment,
      enableEventMemorableMoment,
      memorableMomentHeaders,
      momentUploadedFile,
      momentAdded,
      moveMomentUp,
      moveMomentDown,
      removeMoment,

      // save,
    }
  }
}
</script>
